import Vue from 'vue'
import Router from 'vue-router'

import LoginView from "./views/public/LoginView";
import LoginSuccess from "./views/public/LoginSuccess";
import ForgotPasswordView from "./views/public/ForgotPasswordView";

const AdminTokenView = () => import(/* webpackChunkName: "admin" */ './views/admin/TokenListView.vue')
const UserManagementView = () => import(/* webpackChunkName: "admin" */ './views/admin/UserManagementView.vue')
const UserDetailView = () => import(/* webpackChunkName: "admin" */ './views/admin/UserDetailView.vue')
const RootAdminView = () => import(/* webpackChunkName: "admin" */ './views/admin/RootAdminView.vue')

const ResetPasswordView = () => import(/* webpackChunkName: "reset" */ './views/public/ResetPasswordView.vue')

const InvitationView = () => import(/* webpackChunkName: "invitation" */ './views/public/InvitationView.vue')

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: "/login",
			name: "login",
			component: LoginView
		},
		{
			path: "/forgot",
			name: "forgot",
			component: ForgotPasswordView
		},
		{
			path: "/invitation",
			name: "invitation",
			component: InvitationView
		},
		{
			path: "/success",
			name: "success",
			component: LoginSuccess
		},
		{
			path: "/reset",
			name: "reset",
			component: ResetPasswordView
		},
		{
			path: '/admin/tokens',
			name: 'tokenList',
			component: AdminTokenView
		},
		{
			path: '/admin',
			name: 'rootAdmin',
			component: RootAdminView
		},
		{
			path: '/admin/users',
			name: 'usersList',
			component: UserManagementView
		},
		{
			path: '/admin/users/:userId',
			name: 'userDetail',
			component: UserDetailView
		}
	]
})
